let LOCAL_STORAGE_WISHLIST_KEY = "shopify-wishlist",
    LOCAL_STORAGE_DELIMITER = ",",
    BUTTON_ACTIVE_CLASS = "active",
    GRID_LOADED_CLASS = "loaded",
    selectors = {
        button: "[button-wishlist]",
        grid: "[grid-wishlist]",
        gridOutOfStock: "[grid-wishlist-out-of-stock]",
        productCard: ".product-item--vertical"
    };
    document.addEventListener("DOMContentLoaded", (() => {
        initButtons(), initGrid(), initGridOutofStock()
    })), document.addEventListener("shopify-wishlist:updated", (t => {
        initGrid(), initGridOutofStock()
    }));

const fetchLink = "https://shopify-api.longdan.co.uk/"
// http://localhost:3001/
// https://shopify-api.longdan.co.uk/

const fetchProductCardHTML = (t, code) => {
    const s = `/products/${t}?view=card`;
        return fetch(s).then((t => t.text())).then((t => {
            const s = t,
                i = (new DOMParser).parseFromString(s, "text/html").documentElement.querySelector(selectors.productCard);
            let element = i.querySelectorAll('.product-item__action-button')[0];

            if(code === 'on' && element.textContent.includes('Add to cart')){
                return i.classList.add("1/3--tablet"), i.classList.add("1/4--lap-and-up"), i.outerHTML
            }

            if(code === 'off' && element.textContent.includes('Sold out')){
                return i.classList.add("1/3--tablet"), i.classList.add("1/4--lap-and-up"), i.outerHTML
            }
        })).catch((s => console.error(`[Shopify Wishlist] Failed to load content for handle: ${t}`, s)))
    },
    setupGrid = async (t, code) => {
        const s = getWishlist(),
            i = s.map(product => {
                return fetchProductCardHTML(product, code)
            });
            let e = (await Promise.all(i)).join("");
        t.innerHTML = e, t.classList.add("loaded"), initButtons();
        const o = new CustomEvent("shopify-wishlist:init-product-grid", {
            detail: {
                wishlist: s
            }
        });
        document.dispatchEvent(o)
    }, setupButtons = t => {
        t.forEach((t => {
            const s = t.dataset.productHandle || !1;
            if (!s) return console.error("[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.");
            wishlistContains(s) && t.classList.add("active"), t.addEventListener("click", (() => {
                updateWishlist(s), t.classList.toggle("active")
            }))
        }))
    }, initGrid = () => {
        const t = document.querySelector(selectors.grid) || !1;
        t && setupGrid(t, 'on')
    },
    initGridOutofStock = async t => {
        const tOff = document.querySelector(selectors.gridOutOfStock) || !1;
        tOff && setupGrid(tOff, 'off')
    }, initButtons = () => {
        const t = document.querySelectorAll(selectors.button) || [];
        if (!t.length) return;
        setupButtons(t);
        const s = new CustomEvent("shopify-wishlist:init-buttons", {
            detail: {
                wishlist: getWishlist()
            }
        });
        document.dispatchEvent(s)
    }, getWishlist = () => {
        const customerId = document.getElementById('customer-id');
        const wishListItem = localStorage.getItem('shopify-wishlist');

        if(customerId.value !== "/" && wishListItem === undefined)
            fetch(fetchLink.concat(`wishlist/${customerId}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                }
            }))
            .then(response => {
                return response.json();
            })
            .then(data => {
                setWishlist(data.response.wishlist.join(","));
                return data.description.wishlist;
            })

        if(wishListItem){
            return wishListItem.split(",")
        }
        return [];
    }, setWishlist = (t, customerId) => {
        if (customerId) {
            let wishlistCount = document.getElementById('header__wishlist-count');
            fetch(fetchLink.concat("wishlist"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json"
                },
                body: JSON.stringify({
                    id: t,
                    customerId: customerId
                })
            })
            .then(response => {
                return response.json();
            })
            .then(data => {
                const i = new CustomEvent("shopify-wishlist:updated", {
                    detail: {
                        wishlist: data.description.wishlist
                    }
                });

                const s = data.description.wishlist.join(",");
                if (data.description.wishlist.length) {
                    localStorage.setItem("shopify-wishlist", s);
                    wishlistCount.textContent = data.description.wishlist.length;
                }else{
                    localStorage.removeItem("shopify-wishlist")
                }
                return document.dispatchEvent(i), s
            })
        }else{
            const wishListItem = localStorage.getItem('shopify-wishlist');
            let wishlistCount = document.getElementById('header__wishlist-count');
            let wishlistArray = wishListItem ? wishListItem.split(",") : [];
            if (wishlistArray.includes(t)) {
                wishlistArray = wishlistArray.filter(item => item !== t);
                wishlistCount.textContent = wishlistArray.length;
            } else {
                wishlistArray.push(t);
                wishlistCount.textContent = wishlistArray.length;
            }

            console.log(wishlistCount.textContent);

            localStorage.setItem('shopify-wishlist', wishlistArray.join(","));

            const i = new CustomEvent("shopify-wishlist:updated", {
                detail: {
                    wishlist: wishListItem.split(",").length > 0 ? wishListItem.split(","):[]
                }
            });

           return document.dispatchEvent(i), ''
        }


    }, updateWishlist = t => {
        const customerId = document.getElementById('customer-id');
        return setWishlist(t, customerId.value);
    }, wishlistContains = t => getWishlist().includes(t), resetWishlist = () => setWishlist([]);